var version = {
    "name":      "dativery",
    "buildDateCode": "20260112-175450",
    "buildDate": "Mon Jan 12 2026 17:54:50 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260112-175450",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;